import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { ChartText } from "../../CheckItem/styles";

export const HeaderBlock = ({ data, showDetails }) => {
  const { score } = data || {};

  const remaining = 100 - score;

  const chartData = {
    labels: [],
    datasets: [
      {
        label: [],
        data: [score, remaining],
        backgroundColor: ["#F7CF51", "#F4DFB5"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    cutout: "62%",
    plugins: {
      legend: { display: false },
    },
  };

  return (
    <Stack width="100%" direction="row" gap="30px" alignItems="center">
      <Box sx={{ width: "150px", height: "150px", position: "relative" }}>
        <Doughnut data={chartData} options={options} />
        <ChartText variant="h3" sx={{ fontSize: "21px !important" }}>
          {score}%
        </ChartText>
      </Box>

      <Typography variant="h2">Dataset {showDetails} review</Typography>
    </Stack>
  );
};
